module.exports = __webpack_public_path__ + "static/img/shouquanshu.d662083c.png";